<template>
    <v-container class="resources-adv__list pa-0 pt-10">
        <v-row>
            <v-col
                v-for="resourceItem in resourcesItems"
                :key="resourceItem.resource_id"
                class="resources-adv__list-item"
                :cols="getColsByDisplayWidth"
            >
                <div>
                    <router-link 
                        :to="resourceLink(resourceItem)"
                    >
                        <div  
                            v-if="resourceItem.resource_type === 3" 
                            class="resources-adv__list-item-img pl-4" 
                        >
                            <Icon
                                :type='resourceItem.ico'
                                :color='resourceItem.color'
                                :size='100'
                                :pr="16"
                            />
                        </div>
                        <div   
                            v-else
                            class="resources-adv__list-item-img pl-6"
                            :style="{ backgroundImage: backgroundImage(resourceItem) }"
                        >
                            <div v-if="backgroundImage(resourceItem) === 'none'">
                                <ResourceFileIcon  :fileName="resourceItem.upload.file_real_name" :url="resourceItem.upload.url" />
                            </div>
                            <div v-else class="resources-adv__list-item-img-file-icon">
                                <ResourceFileIcon  :fileName="resourceItem.upload.file_real_name" :url="resourceItem.upload.url" />
                            </div>
                        </div>
                    </router-link>
                    <div class="d-flex">
                        <router-link :to="resourceLink(resourceItem)" style="text-decoration: none;">
                            <p class="resources-adv__list-item-title ma-0 mt-2" style="text-decoration: underline;">
                                {{ resourceItem.resources_name || resourceItem.upload.file_real_name }}
                            </p>
                        </router-link>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ResourceFileIcon from './ResourceFileIcon.vue'
import Icon from '@/components/Icon'

export default {
    components: {
        Icon,
        ResourceFileIcon,
    },
    props: {
        resourcesItems: {
            type: Array,
            default: () => [],
        }
    },
    methods: {
        resourceLink(resourceItem) {
            const name = resourceItem.resource_type === 3 ? 'resource' : 'resource-file'
            const params = {
                name,
                params: {
                    id: resourceItem.resource_id
                }
            }
            if (resourceItem.resource_type === 3) {
                params.query = {advance: '1', title: resourceItem.resources_name}
            }
            return params
        },
        backgroundImage(resourceItem) {
            return resourceItem.resource_image ? `url(${resourceItem.resource_image})` : 'none'
        },
        fileType(resourceItem) {
            if (resourceItem.upload.metadata) {
                return resourceItem.upload.filename.substring(resourceItem.upload.filename.lastIndexOf('.') + 1)
            } else {
                return 'file'
            }
        }
    },
    computed: {
        getColsByDisplayWidth() {
            const displayWidth = this.$vuetify.breakpoint.width
            return displayWidth >= 600 ? '4' : displayWidth <= 380 ? '12' : '6'
        }
    }
}
</script>

<style lang="scss">
.resources-adv__list {
    &-item {
        &-img {
            background-color: #F3F3F6;
            border-radius: 8px;
            height: 152px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            position: relative;

            &-file {
                background-color: var(--accent-color);

                &-icon, &-icon-small {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    bottom: 4px;
                    right: -12px;

                    img {
                        height: 20px;
                        width: 20px;
                    }

                    &-small {
                        width: 20px;
                        height: 20px;
                        border-radius: 4px;
                        right: 12px;
                    }
                }
                &-icon-common {
                    img {
                            mix-blend-mode: multiply;
                    }
                }
            }
        }

        &-title {
            font-size: 12px;
            font-weight: 700;
            color: var(--ceil-detail-text-color);
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-word;
        }
    }
}
</style>